import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const avg = (l) => (l.length ? l.reduce((a, b) => a + b, 0) / l.length : null);

const supplierStats = (orders) => {
  const by = {};
  orders.forEach((o) => {
    const s = (by[o.supplier] ||= { supplier: o.supplier, open: 0, days: [], short: 0, late: 0, ratio: [] });
    if (o.status !== "arrivato") { s.open += 1; return; }
    if (o.delivery_days != null) s.days.push(o.delivery_days);
    if (o.received_qty < o.quantity) s.short += 1;
    if (o.expected_date && o.received_date > o.expected_date) s.late += 1;
    if (o.quantity) s.ratio.push((o.received_qty / o.quantity) * 100);
  });
  return Object.values(by).map((s) => ({ ...s, done: s.days.length, avgDays: avg(s.days), avgRatio: avg(s.ratio) }))
    .sort((a, b) => b.done - a.done || a.supplier.localeCompare(b.supplier));
};

const pct = (a, b) => (b ? `${num(Math.round((a / b) * 100))}%` : "–");

export const SupplierStats = ({ orders }) => {
  const rows = supplierStats(orders);
  if (!rows.length) return null;
  return (
    <Card className="mb-6 overflow-hidden" data-testid="po-supplier-stats">
      <div className="border-b border-border/60 px-6 py-4">
        <h3 className="font-display text-lg font-semibold">Tempi per fornitore</h3>
        <p className="text-xs text-muted-foreground">Calcolati sugli ordini arrivati: giorni dall'ordine all'arrivo e consegne con meno merce di quella ordinata.</p>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead>Fornitore</TableHead><TableHead className="text-right">Ordini arrivati</TableHead>
            <TableHead className="text-right">Consegna media</TableHead><TableHead className="text-right">Min – max</TableHead>
            <TableHead className="text-right">Consegne incomplete</TableHead><TableHead className="text-right">Merce ricevuta</TableHead>
            <TableHead className="text-right">In ritardo</TableHead><TableHead className="text-right">In arrivo</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((s) => (
            <TableRow key={s.supplier} data-testid={`po-supplier-${s.supplier}`}>
              <TableCell className="font-medium">{s.supplier}</TableCell>
              <TableCell className="text-right text-sm">{num(s.done)}</TableCell>
              <TableCell className="text-right text-sm font-semibold">{s.avgDays == null ? "–" : `${num(Math.round(s.avgDays * 10) / 10)} giorni`}</TableCell>
              <TableCell className="text-right text-sm text-muted-foreground">{s.done ? `${Math.min(...s.days)} – ${Math.max(...s.days)} gg` : "–"}</TableCell>
              <TableCell className={`text-right text-sm ${s.short ? "text-amber-400" : ""}`}>{s.done ? `${num(s.short)} su ${num(s.done)} (${pct(s.short, s.done)})` : "–"}</TableCell>
              <TableCell className="text-right text-sm">{s.avgRatio == null ? "–" : `${num(Math.round(s.avgRatio))}% dell'ordinato`}</TableCell>
              <TableCell className={`text-right text-sm ${s.late ? "text-rose-400" : ""}`}>{s.done ? num(s.late) : "–"}</TableCell>
              <TableCell className="text-right text-sm">{num(s.open)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};
